export default "__VITE_ASSET__2e16a617__"